<template>
  <div>
    <button v-on:click.stop @click.prevent="decreaseNumber" :class="buttonClass">-</button>
    <input type="number" v-bind:value="numericValue" @keypress="validateInput"
      @input="numericValue = $event.target.value" :class="inputClass" :min="min" :max="max" debounce="500" />
    <button v-on:click.stop @click.prevent="increaseNumber" :class="buttonClass">+</button>
  </div>

</template>

<script>
export default {
  name: 'NumberTextFieldSpinner2',
  props: {
    value: {
      type: Number,
      default: 0
    },
    min: {
      default: 0,
      type: Number
    },
    max: {
      default: 10,
      type: Number
    },
    step: {
      default: 1,
      type: Number
    },
    inputClass: {
      default: 'vnis__input',
      type: String
    },
    buttonClass: {
      default: 'vnis__button',
      type: String
    },
    integerOnly: {
      default: false,
      type: Boolean
    },
    changeEvent: {
      default: null,
      type: String
    },
    objectEvent: {
      default: null,
      type: Object
    }
  },
  data: function () {
    return {
      numericValue: this.value,
      cantidadtxt: 'Cant',
      // borderBottom: 'border-bottom:1px solid #AAA; height:50px'
      borderBottom: 'data-NTFSpinnerBorderBottomDesactive'
    }
  },
  watch: {
    /**
     * Comprueba si el valor es numerico
     */
    numericValue: function (val, oldVal) {
      if (val !== '') {
        if (val <= this.min) {
          this.numericValue = parseInt(this.min)
        }
        if (val >= this.max) {
          this.numericValue = parseInt(this.max)
        }
        if (val <= this.max && val >= this.min) {
          this.$emit('input', parseFloat(val), oldVal)
          if (this.objectEvent !== null) {
            this.$bus.$emit(this.changeEvent, this.objectEvent, parseFloat(val))
          }
        }
      }
    },
    /**
     * Comprueba las modificaciones de value
     */
    value: {
      handler() {
        this.numericValue = this.value
      }
    }
  },
  methods: {
    /**
     * Incrementa un numero
     */
    increaseNumber() {
      let temp
      if (this.integerOnly) {
        temp = this.numericValue + this.step
        this.numericValue = temp
      } else {
        temp = parseFloat(this.numericValue) + parseFloat(this.step)
        this.numericValue = temp.toFixed(2)
      }
    },
    /**
     * Decrementa un numero
     */
    decreaseNumber() {
      let temp
      if (this.integerOnly) {
        temp = this.numericValue - this.step
        this.numericValue = temp
      } else {
        temp = parseFloat(this.numericValue) - parseFloat(this.step)
        this.numericValue = temp.toFixed(2)
      }
    },
    /**
     * Comprueba si es integer
     */
    isInteger(evt) {
      if (!evt) {
        evt = window.event
      }
      let key = evt.keyCode || evt.which
      key = String.fromCharCode(key)
      const regex = /[0-9]/
      if (!regex.test(key)) {
        evt.returnValue = false
        if (evt.preventDefault) {
          evt.preventDefault()
        }
      }
    },
    /**
     * Comprueba si es numero
     */
    isNumber(evt) {
      if (!evt) {
        evt = window.event
      }
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 44) {
        evt.preventDefault()
        return false
      } else {
        return true
      }
    },
    /**
     * Valida la entrada de datos
     */
    validateInput(evt) {
      if (this.integerOnly === true) {
        this.isInteger(evt)
      } else {
        this.isNumber(evt)
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components_datadec/NumberTextFieldSpinner2.vue